<template>
    <div :class="$style['new-after-sales-policie']">
        <div :class="$style['new-after-sales-policie-table-message']">
        <table>
            <pt-form-list-item label="名称：" :required="true" >
                <wt-input v-model="form.name" data-vv-as="名称"
            name="type"  v-validate="'required'"></wt-input>
            </pt-form-list-item>
            <pt-form-list-item label="内容：" :required="true" >
                 <wt-ueditor v-if="isSimditorTextarea" resource="" ref="ueditor"  v-model="form.content" :content="content" data-vv-as="内容"
            name="content"  v-validate="'required'" :class="$style['policy-form-ueditor']" :initialHeight="400"></wt-ueditor>
                <!-- <wt-simditor-textarea v-if="isSimditorTextarea" v-model="form.content" :content="content" :publicImageUrl="privateResourcesUrl" :fileUploadUrl="fileUploadUrlKey"
        :params="picture_params_sim" :class="$style['new-after-sales-policie-simditor-textarea']" data-vv-as="内容"
            name="type"  v-validate="'required'"></wt-simditor-textarea> -->
                <wt-input data-vv-as="内容" name="type"  v-validate="'required'" v-else v-model="form.detail"  type="textarea" rows='4' :autosize="{ minRows: 4, maxRows: 30}"
                :placeholder="placeholder" :max-length="policyContentMax?policyContentMax:Infinity"></wt-input>
            </pt-form-list-item>
        </table>
        </div>
        <div class="button-div">
            <el-button type="primary" :loading="loading" @click="sumit">保存</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  props: {
    policyType: {
      type: String,
      default: ''
    },
    policyContentMax: {
      type: Number,
      default: 0
    },
    fromPage: String
  },
  data () {
    return {
      form: {},
      loading: false,
      privateResourcesUrl: this.$publicResourcesUrl,
      fileUploadUrl: this.$uploadApi,
      fileUploadUrlKey: this.$uploadApiKey,
      picture_params_sim: {
        resourceName: 'goods',
        objectId: this.id || 0,
        key: 'file_path'
      },
      content: ''
    }
  },
  computed: {
    // 是否售后政策
    isAfterSalesPolicy () {
      return this.policyType === 'afterSalesPolicy'
    },
    // 是否运费模板
    isCarriagePolicy () {
      return this.policyType === 'carriagePolicy'
    },
    // 是否是隐私条款
    isPrivacyPolicy () {
      return this.policyType === 'privacyPolicy'
    },
    // 提示文字
    placeholder () {
      return '请输入' + (this.isCarriagePolicy ? '运费规则描述' : '') + (this.policyContentMax ? '(最多输入' + this.policyContentMax + '个字)' : '')
    },
    // 内容是否需要富文本
    isSimditorTextarea () {
      return this.isPrivacyPolicy || this.isAfterSalesPolicy
    }
  },
  methods: {
    sumit () {
    //   let content = this.$refs.ueditor.getUEContent() // 调用子组件方法
    //   this.form.content = content
      let apiUrl
      if (this.fromPage === 'integral') {
        apiUrl = this.isCarriagePolicy ? 'createIntegralCarriagePolicies' : (this.isPrivacyPolicy ? 'createIntegralPrivacyPolicies' : 'createIntegralAfterSalesPolicies')
      } else {
        apiUrl = this.isCarriagePolicy ? 'creatCarriagePolicies' : (this.isPrivacyPolicy ? 'createPrivacyPolicies' : 'creatAfterSalesPolicies')
      }
      let data = this.isCarriagePolicy || this.isPrivacyPolicy ? { name: this.form.name, content: this.form.content || this.form.detail } : this.form
      let text = this.isCarriagePolicy ? '运费规则' : (this.isPrivacyPolicy ? '隐私条款' : '售后政策')
      if (this.isAfterSalesPolicy) {
        this.form.detail = this.form.content
        this.$delete(this.form, 'content')
      }
      this.validate().then(res => {
        this.loading = true
        this.$store.dispatch(apiUrl, data).then(res => {
          this.loading = false
          this.$message.success('新建' + text + '成功')
          this.$emit('closeDialog', res)
        }).catch(err => {
          this.loading = false
          this.$message.error(err || '新建' + text + '失败')
        })
      })
    },
    cancel () {
      this.$emit('closeDialog')
    }
  }

}
</script>
<style module lang="less">
.new-after-sales-policie{
    display: flex;
    flex-direction: column;
    width: 100%
}
.new-after-sales-policie-table-message{
    width: 100%;
    :global
    table{
        width: 100%
    }

}
.policy-form-ueditor{
    td{
        padding-bottom: inherit
    }
}
</style>
